/**
 * Die Reiterleiste des Bestell-Drawers - Portierung von `index.html:9283-9285` (`.dtabs`).
 *
 * Original, woertlich:
 *
 *     <div class="dtabs">
 *       ${DRAWER_TABS.map(t => `<button class="dtab ${t.id === drawerTab ? 'active' : ''}"
 *          onclick="gotoTab('${t.id}')">${icon(DRAWER_TAB_ICONS[t.id])}${t.label}</button>`).join('')}
 *     </div>
 *
 * ================= Der Satz, den diese Leiste traegt (Global Constraint 9) ==================
 *
 * KEIN Knopf traegt hier eine Rechtepruefung. `gotoTab` (`index.html:8377`) hat ebenfalls keine.
 * Jeder Reiter ist damit fuer jeden erreichbar, der den Drawer ueberhaupt sieht - das Schreibrecht
 * des Reiters (`DRAWER_TAB_EDIT_PERMISSIONS`) entscheidet erst ueber die Bedienelemente DARIN.
 * Deshalb nimmt diese Komponente den Rechtesatz bewusst NICHT als Prop entgegen: sie koennte ihn
 * nur falsch verwenden.
 */
import { DRAWER_TABS, DRAWER_TAB_ICONS } from "./drawerRechte.ts";
import type { DrawerTabId } from "./drawerRechte.ts";

/**
 * `icon(name, className)` (`index.html:4016`) samt der Nachbearbeitung durch `hydrateIcons`
 * (`:4021`) - die gemeinsame Registratur zeichnet das fertige `<svg class="lucide lucide-…">`.
 *
 * Bis `feat/09-spa-ikonen` stand hier eine LOKALE Funktion, die nur den Platzhalter
 * `<i data-lucide="…">` erzeugte. Den hydriert in der SPA niemand (die UMD-Fassung laeuft allein
 * im Baseline-Rundlauf des Playwright-Harness) - es blieb eine leere Flaeche. Siehe `Ikone.tsx`.
 */
import { Ikone } from "../Ikone.tsx";

export interface TabLeisteProps {
  tab: DrawerTabId;
  /** `gotoTab(id)` (`index.html:8377`). */
  onTab: (tab: DrawerTabId) => void;
}

export function TabLeiste({ tab, onTab }: TabLeisteProps) {
  return (
    <div className="dtabs">
      {DRAWER_TABS.map((t) => (
        <button
          key={t.id}
          className={`dtab ${t.id === tab ? "active" : ""}`}
          onClick={() => onTab(t.id)}
        >
          <Ikone name={DRAWER_TAB_ICONS[t.id]} />
          {t.label}
        </button>
      ))}
    </div>
  );
}
